import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Input, Icon } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Image, Dimensions, View } from 'react-native';

import {useSelector, useDispatch} from 'react-redux';


const CallIcon = (props) => (
  <Icon {...props}  name='phone-call'/>
);

const BookmarkIcon = (props) => (
  <Icon {...props}  name='bookmark'/>
);

const  width= Dimensions.get('window').width
export const CustomerInfo = () => {
  const data = useSelector( state => state.request.data);

  return (
        <View style={{width, justifyContent:'space-between', alignItems:'flex-start'}}>
          <View style={{flexDirection:'row'}}>
            <Layout style={{ backgroundColor:'#134A93', flex:2, borderTopRightRadius:30, borderBottomLeftRadius:30}}>
            <Text category='c1' style={{marginHorizontal:5, marginTop:5, color:'#f5f5f5'}}>تاریخ تخصیص {data.register_date.split('T')[0]} ساعت {data.register_date.split('T')[1]}</Text>
              <Divider style={{marginTop:5, marginHorizontal:10, marginRight:50}} />
              <Text category='h6' appearance='hint' style={{marginHorizontal:5, marginTop:5}}>اطلاعات مشتری</Text>
              <View style={{flexDirection:'row',marginHorizontal:5, marginTop:5, alignItems:'center', justifyContent:'space-between'}}>
                <Text style={{color:'#f5f5f5'}}>{data.merchant_name}</Text>
                <Text style={{color:'#f5f5f5', marginRight:20}}>{data.merchant_phone}</Text>

              </View>


              <View style={{flexDirection:'row',marginHorizontal:5, marginTop:5, alignItems:'center'}}>
                <Text style={{color:'#f5f5f5', lineHeight:23}}>آدرس: {data.merchant_city}، {data.merchant_address}</Text>
              </View>
              <View style={{ alignItems:'center' ,marginHorizontal:5, marginTop:15,width, flexDirection:'row'}}>
                <Text category='c1' appearance='hint'>مدل دستگاه: </Text>
                <Text style={{color:'#f5f5f5'}}>{data.product_category} {data.product_model}</Text>
              </View>
            </Layout>
            <View style={{flex:1}}>
              <View style={{backgroundColor:'#134A93',backgroundColor:'#134A93'}}>
                <Layout level='3' style={{flex:1 , borderBottomLeftRadius:20}}>
                  <Text appearance='hint' category='c1' style={{marginHorizontal:5, marginTop:15}}>شماره کار: </Text>
                  <Text status='primary' category='h4' style={{marginHorizontal:15, textAlign:'center'}}>{data.id}</Text>
                </Layout>
              </View>
              { true &&

              <Layout style={{flex:1 , borderTopRightRadius:20, backgroundColor:'#134A93', alignItems:'center'}} >
              { data.service_type ==='تعمیر' &&
                <Image style={{width:60, height:60, marginVertical:15, marginHorizontal:10}} source={require('../../../assets/service.png')} />
              }
              { data.service_type !='تعمیر' &&
                <Image style={{width:60, height:60, marginVertical:15, marginHorizontal:10}} source={require('../../../assets/install.png')} />
              }

                <Text  style={{marginBottom:10 ,color:'#f5f5f5'}}>{data.service_type}</Text>
              </Layout>
            }
            { false &&

            <Layout style={{flex:1 , borderTopRightRadius:20, backgroundColor:'#134A93', alignItems:'center'}} >
              <Image style={{width:60, height:60, marginVertical:15, marginHorizontal:10}} source={require('../../../assets/install.png')} />
              <Text  style={{marginBottom:10 ,color:'#f5f5f5'}}>نصب و راه اندازی</Text>
            </Layout>
          }
            </View>
          </View>
          <View style={{backgroundColor:'#134A93'}}>

          </View>
        </View>

  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    justifyContent:'space-around',
    alignItems:'center'
  },
  box:{
    borderRadius:10,
    width:width-10,
    marginHorizontal:10,
    marginVertical:5,
    padding:10
  }
});
